import { useMemo, useState } from 'react';
import { Select, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import { useOperatorStore } from '../../store/useOperatorStore';
import WarningMessage from '../../components/WarningMessage';
import FactoryTouBoard from './FactoryTouBoard';
import { useFetchTouMonthStatus } from './Hooks';

const { Title, Text } = Typography;

const getYearOptions = () => {
  const current = dayjs().year();
  const options = [];
  for (let year = current - 2; year <= 2090; year += 1) options.push(year);
  return options;
};

export default function TouPricingPage() {
  const { t } = useTranslation('touPricing');
  const { operatorId } = useOperatorStore();
  const [params] = useSearchParams();
  const initial = dayjs();
  const [year, setYear] = useState(Number(params.get('year')) || initial.year());
  const [month, setMonth] = useState(Number(params.get('month')) || initial.month() + 1);
  const statusQuery = useFetchTouMonthStatus(operatorId, year, month, !!operatorId);

  const counts = useMemo(() => {
    const rows = [
      statusQuery.data?.fallback,
      ...(statusQuery.data?.factories || []),
    ].filter(Boolean);
    return {
      ready: rows.filter((row) => row.status === 'COMPLETE').length,
      gaps: rows.filter((row) => row.status === 'HAS_GAPS').length,
      missing: rows.filter((row) => row.status === 'NOT_SET').length,
    };
  }, [statusQuery.data]);

  if (!operatorId) return <WarningMessage />;

  return (
    <div>
      <Space wrap className="mb-4">
        <Select
          value={year}
          onChange={setYear}
          options={getYearOptions().map((value) => ({ value, label: value }))}
          style={{ width: 120 }}
        />
        <Select
          value={month}
          onChange={setMonth}
          options={Array.from({ length: 12 }, (_, index) => ({
            value: index + 1,
            label: t(`months.${index + 1}`),
          }))}
          style={{ width: 160 }}
        />
        <Text>{t('summaryReady', counts)}</Text>
      </Space>
      <FactoryTouBoard operatorId={operatorId} year={year} month={month} />
    </div>
  );
}
